import { useEffect, useState } from "react";
import { LoggedInAppArgs } from "../App";
import { GameData } from "../Data/Response";
import AddPlayerModal from "./AddPlayerModal";
import styles from './ScapeGameView.module.scss';
import { Link } from "react-router-dom";

interface ScapeGameViewArgs extends LoggedInAppArgs {
    gameId: string;
}

const ScapeGameView: React.FC<ScapeGameViewArgs> = args => {
    const [game, setGame] = useState<GameData | null>()
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const getScapes = async (): Promise<GameData> => {
        setIsLoading(true);
        const token = await args.loggedInUser.getAccessToken();

        const response = await fetch(`/api/v1.0/games/${args.gameId}`, {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}` // if using JWT auth
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error ${response.status}`);
        }
        setIsLoading(false);
        return await response.json(); // return parsed data
    }

    const addPlayer = async (playerId: string) => {
        setIsLoading(true);
        console.log("Set is loading");
        try {
            const token = await args.loggedInUser.getAccessToken();

            const addPlayerResponse = await fetch(`/api/v1.0/games/${args.gameId}/AddPlayer`, {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`, // if using JWT auth,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ playerUserId: playerId })
            });

            if (!addPlayerResponse.ok) {
                throw new Error(`HTTP error ${addPlayerResponse.status}`);
            }

            const response = await fetch(`/api/v1.0/games/${args.gameId}`, {
                method: "GET",
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}` // if using JWT auth
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error ${response.status}`);
            }
            const game: GameData = await response.json(); // return parsed data
            setGame(game);
            args.setModalContent(null);
        } catch (e) {
            var err: Error = e;
            setErrorMessage(e.Message);
            console.log("There was an error.");
        }

        setIsLoading(false);
        // return await response.json(); // return parsed data
    }

    useEffect(() => {
        getScapes()
            .then((result) => {
                console.log(result);
                setGame(result);
            })
            .catch(e => {
                setErrorMessage(`Error getting game: ${e.Message}`);
                console.log(`Error getting game: ${e.Message}`);
            })
    }, []);

    if (isLoading) {
        return <div>Loading Game...</div>
    }

    const addMap = async () => {
        setIsLoading(true);
        console.log("Set is loading");
        try {
            const token = await args.loggedInUser.getAccessToken();

            const addPlayerResponse = await fetch(`/api/v1.0/games/${args.gameId}/SetMap`, {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`, // if using JWT auth,
                    // "Content-Type": "application/json"
                },
                // body: JSON.stringify({ playerUserId: playerId })
            });

            if (!addPlayerResponse.ok) {
                throw new Error(`HTTP error ${addPlayerResponse.status}`);
            }

            const response = await fetch(`/api/v1.0/games/${args.gameId}`, {
                method: "GET",
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}` // if using JWT auth
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error ${response.status}`);
            }
            const game: GameData = await response.json(); // return parsed data
            setGame(game);
            args.setModalContent(null);
        } catch (e) {
            var err: Error = e;
            setErrorMessage(e.Message);
            console.log("There was an error.");
        }

        setIsLoading(false);
        // return await response.json(); // return parsed data
    }

    const addCrews = async () => {
        setIsLoading(true);
        console.log("Set is loading");
        try {
            const token = await args.loggedInUser.getAccessToken();

            const addPlayerResponse = await fetch(`/api/v1.0/games/${args.gameId}/SetArmies`, {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`, // if using JWT auth,
                    // "Content-Type": "application/json"
                },
                // body: JSON.stringify({ playerUserId: playerId })
            });

            if (!addPlayerResponse.ok) {
                throw new Error(`HTTP error ${addPlayerResponse.status}`);
            }

            const response = await fetch(`/api/v1.0/games/${args.gameId}`, {
                method: "GET",
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}` // if using JWT auth
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error ${response.status}`);
            }
            const game: GameData = await response.json(); // return parsed data
            setGame(game);
            args.setModalContent(null);
        } catch (e) {
            var err: Error = e;
            setErrorMessage(e.Message);
            console.log("There was an error.");
        }

        setIsLoading(false);
        // return await response.json(); // return parsed data
    }

    const placeMinis = async () => {
        setIsLoading(true);
        console.log("Set is loading");
        try {
            const token = await args.loggedInUser.getAccessToken();

            const addPlayerResponse = await fetch(`/api/v1.0/games/${args.gameId}/PlaceMinis`, {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`, // if using JWT auth,
                    // "Content-Type": "application/json"
                },
                // body: JSON.stringify({ playerUserId: playerId })
            });

            if (!addPlayerResponse.ok) {
                throw new Error(`HTTP error ${addPlayerResponse.status}`);
            }

            const response = await fetch(`/api/v1.0/games/${args.gameId}`, {
                method: "GET",
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}` // if using JWT auth
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error ${response.status}`);
            }
            const game: GameData = await response.json(); // return parsed data
            setGame(game);
            args.setModalContent(null);
        } catch (e) {
            var err: Error = e;
            setErrorMessage(e.Message);
            console.log("There was an error.");
        }

        setIsLoading(false);
        // return await response.json(); // return parsed data
    }

    if (
        errorMessage ||
        !game
    ) {
        return <div>Fatal Error: {errorMessage ?? "uknown"}</div>
    }

    const isFallout = game.ruleset.id === 'ffnw';
    const hasTwoPlayers = game.players.length === 2;
    const hasMap = game.maps && game.maps.length > 0 && game.currentMapId && game.maps.find(m => m.id === game.currentMapId);
    var hasCrewsAndCharacters = hasTwoPlayers;
    game.players.forEach(p => {
        if (!p.playerArmies || p.playerArmies.length < 1) {
            hasCrewsAndCharacters = false;
            return;
        }
        if (!p.playerCharacters || p.playerCharacters.length < 1) {
            hasCrewsAndCharacters = false;
            return;
        }
    });
    var hasAllMoveables = hasCrewsAndCharacters;
    game.players.forEach(p => {
        if (!p.playerCharacters || p.playerCharacters.length < 1) {
            hasCrewsAndCharacters = false;
            return;
        }
        p.playerCharacters.forEach(pc => {
            if (!pc.moveables || pc.moveables.length < 1) {
                hasAllMoveables = false;
                return;
            }
        });
    })

    return <div className={styles.gameView}>
        <h1>GAME</h1>
        <p>Game Id: {game.id}</p>
        <h2>Players</h2>
        <ul className={styles.playerList}>
            {game.players.map(p => {
                return <li>
                    <img src={p.user.avatar.smallUrl} />
                    <h3>{p.user.username}</h3>
                </li>
            })}
        </ul>
        <h2>Game Prep Checklist</h2>
        <ul>
            <li>{isFallout ? "✅️" : "✖️"} Is Fallout Game</li>
            <li>
                {hasTwoPlayers ? "✅️" : "✖️"} Has Two Players
                {!hasTwoPlayers && <button
                    onClick={e => {
                        args.setModalContent({
                            element: <AddPlayerModal addPlayer={addPlayer} showBot={true} />,
                            canClose: true
                        });
                    }}
                >Add Player</button>}
            </li>
            <li>{hasMap ? "✅️" : "✖️"} Has Map
                {!hasMap && <button
                    onClick={async e => {
                        await addMap();
                    }}
                >Set Map</button>}
            </li>
            <li>{hasCrewsAndCharacters ? "✅️" : "✖️"} Both Players have Crews & Characters Assigned
                {!hasCrewsAndCharacters && <button
                    onClick={async e => {
                        await addCrews();
                    }}
                >Add Crews</button>}
            </li>
            <li>{hasAllMoveables ? "✅️" : "✖️"} All Characters Have Minis placed on map
                {!hasAllMoveables && <button
                    onClick={async e => {
                        await placeMinis();
                    }}
                >Place Minis</button>}
            </li>
        </ul>
        {(isFallout && hasTwoPlayers && hasCrewsAndCharacters && hasMap) ? < Link
            className={styles.launch}
            to={`/Game/${game.id}`}
        >LAUNCH</Link> : <p>Can not launch yet.</p>
        }
    </div >
};

export default ScapeGameView